export const GraphNumberFirstIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8 8H5.25V16L8 13.8721L10.75 16V8H8Z" fill="#616161" />
      <path
        d="M8 12C11.3137 12 14 9.31371 14 6C14 2.68629 11.3137 0 8 0C4.68629 0 2 2.68629 2 6C2 9.31371 4.68629 12 8 12Z"
        fill="#FFC61C"
      />
      <path
        d="M9.00391 8.79999H7.82422V4.26093H7.79297L6.5 5.08124V4.03436L7.89844 3.14374H9.00391V8.79999Z"
        fill="white"
      />
    </svg>
  );
};
